import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {MailBox} from "@/store/api/mailBoxApi"
interface MailBoxState {
    mailBoxList: MailBox[];
}
const initialState: MailBoxState = {
    mailBoxList: [],
}
const mailBoxSlice = createSlice({
    name: 'mailBox',
    initialState,
    reducers: {
        setMailBoxList: (state, action: PayloadAction<MailBox[]>) => {
            state.mailBoxList = action.payload;
        },
        clearMailBoxList: (state ) => {
            state.mailBoxList = [];
        }

    }
})

export const {setMailBoxList, clearMailBoxList} = mailBoxSlice.actions;
export default mailBoxSlice.reducer;